import React from 'react'

export default {
  home: 'Hello',
  switchLang: '中文',
  header: {
    button: '지금 바로 등록하세요',
    slogan: 'TOWER 5 – 새로운 주거단지가 곧 찾아 옵니다'
  },
  invest:<>
    <h5>SHAPE가 판매하는 THE AMAZING BRENTWOOD 의 <br/><span>TOWER 5 분양 예정</span></h5>
    <p>기다릴만한 가치가 있었습니다. The Amazing Brentwood는 메트로 밴쿠버에서 가장 명성있는 도시 생활의 목적지로 우리 곁에 다가왔습니다. 무엇보다 Neighbourhood One의 주택 소유자를 위해 6억 달러 이상의 재산이 창출되었습니다. 이제, 6년 만에 처음으로 부동산 기회를 얻은 Tower 5가 Neighbourhood Two에 그 닻을 내립니다.</p>
  </>,
  stories: {
    card1: {
      title: <>TOWER 5: 지금까지 볼 수 없었던<br/>최고의 REAL ESTATE</>,
      content: 'SkyTrain이 바로 문 앞에서 이어지고 The Amazing Brentwood는 발 아래 위치해 있습니다. 이 곳에 산다는 것은 바로 이 모든 것을 누릴 권리를 갖게 된다는 것입니다. 북적거리는 중심부에서 한 발 떨어져 우뚝 솟은 산과 강의 아름다운 전망을 감상할 수 있는 Tower 5는 Neighbourhood One의 에너지와 활기가 연결된 가장 매력적인 위치에 자리 잡고 있으며 뜨거운 관심을 받고 있는 Neighbourhood Two중에서도 가장 인기를 끌고 있는 단지입니다. ',
      caption: 'TOWER 5: 지금까지 볼 수 없었던 최고의 REAL ESTATE'
    },
    card2: {
      title: 'TOWER 5: 대중교통과 바로 연결되어 있으며 시장을 선도하는 소매 비즈니스 경험을 제공',
      content: '10년 동안 12억 달러 이상을 Neighbourhood One에 투자한 The Amazing Brentwood는 메트로 밴쿠버의 모습을 바꾸어 가고 있습니다. 그 첫번째 단계로는 완공된 주거용 타워 3개동, 400,000 스퀘어피트 규모의 소매점, 이벤트와 예술 및 문화가 있는 중앙 광장, BC에서의 첫번째 The Rec Room 입점 및 H&M Home, Cineplex VIP, Sephora, Nike, Adidas, Earls, Tap & Barrel, HaiDiLao Hotpot, LL Bean, La Taqueria, Small Victory Bakery, 그리고 Bella Gelateria를 포함한 엄선된 소매점 컬렉션의 입점을 통하여 최고의 생활 문화 공간을 창출하였습니다. 이 아래층에 들어 오게 될 모든 것들과 새로운 상점, 그리고 레스토랑이 Neighbourhood Two에 입점하게 되면 입주자들은 메트로 밴쿠버에서 가장 인기있는 새로운 목적지의 VIP가 될 것입니다.',
      caption: 'Neighbourhood One'
    },
    card3: {
      title: <>TOWER 5: 혁신적인 새로운 주택<br/>디자인이 모습을 드러내다</>,
      content: '타의 추종을 불허하는 기능과 시간을 초월한 디자인으로 유명한 SHAPE가 보증하는 이 주거단지는 입주자들의 생활 경험을 한 단계 높은 곳으로 끌어올리기 위해 재창조되었습니다. 도시 생활을 재정의할 미래 지향적인 기능과 혁신적인 구성. 사방에서 즐길 수 있는 숨막힐 듯 아름다운 전망. 최고의 피트니스, 엔터테인먼트 및 웰빙 시설을 갖춘 10,000 스퀘어피트의 입주자 전용 편의 시설. 이와 같은 생활을 제공하는 주거단지는 그 어디에도 없습니다.',
      caption: '새로운 SHAPE 주방 디자인'
    }
  },
  register: {
    title: [
      '지금 관심을 가지고 TOWER 5에 ',
      '오늘 바로 등록하십시오.',
      ''
    ],
    form: {
      firstName: '이름*',
      lastName: '성*',
      email: '이메일*',
      phone: '전화번호*',
      postalCode: '우편 번호*',
      country: '국가',
      hearAbout: '우리에 대해 어떻게 들었습니까? *',
      isRealtor: '부동산 중개인이세요? *',
      isRealtorEmployer: '고용주/소속회사 *',
      isWorkingWithRealtor: '부동산 중개인과 함께 일하고 있습니까?',
      isWorkingWithRealtorName: '리얼터 이름',
      isWorkingWithRealtorEmail: '리얼터 이메일*',
      isWorkingWithRealtorBrokerage: '리얼터 소속회사',
      isHomeownerAtTAB: 'The Amazing Brentwood의 리테일업체 / Tower One 세입자 / 현재 주택 소유자입니까? (하나를 선택하십시오)**',
      isTABRetailer: 'Are you a Retailer at The Amazing Brentwood?',
      isTABTenant: 'Are you a Rental Tenant at The Amazing Brentwood?',
      isTABHomeowner: 'Are you a Homeowner at The Amazing Brentwood?',
      questionSelections: {
        hearAbout: {
          id: 'answers[3038][answers]',
          options: [
            {
              value: 'Email Outreach',
              content: '이메일'
            },
            {
              value: 'Facebook',
              content: '페이스북'
            },
            {
              value: 'Friends and Family',
              content: '친구와 가족'
            },
            {
              value: 'Instagram',
              content: '인스타그램'
            },
            {
              value: 'MLS',
              content: 'MLS'
            },
            {
              value: 'Online Search',
              content: '온라인 검색'
            },
            {
              value: 'Print Publication',
              content: '신문 등 인쇄물'
            },
            {
              value: 'Realtor',
              content: '부동산 중개인'
            },
            {
              value: 'Signage/Walk- or Drive-by',
              content: '간판/도보 또는 운전'
            },
            {
              value: 'WeChat',
              content: '위챗'
            },
            {
              value: 'Other',
              content: '기타'
            },
          ]

        },
        isRealtor: {
          id: 'agent',
          options: [
            {
              value: 'false',
              content: '아니요'
            },
            {
              values: 'true',
              content: '예'
            }
          ]
        },
        isWorkingWithRealtor: {
          id: 'answers[8454][answers]',
          options: [
            {
              value: 'No',
              content: '아니요'
            },
            {
              values: 'Yes',
              content: '예'
            }
          ]
        },
        isOrWorkingWithRealtor: {
          id: 'isOrWorkingWithRealtor',
          options: [
            {
              value: 'Yes, I am realtor',
              content: 'Yes, I am realtor'
            },
            {
              values: 'No, I am not a realtor',
              content: 'No, I am not a realtor'
            },
            {
              value: 'Yes, I am working with a realtor',
              content: 'Yes, I am working with a realtor'
            },
            {
              values: 'No, I am not working with a realtor',
              content: 'No, I am not working with a realtor'
            }
          ]
        },
        isHomeownerAtTAB: {
          id: 'isHomeownerAtTAB',
          options: [
            {
              value: 'No, none of the above',
              content: '아니요, 해당 사항 없습니다.'
            },
            {
              values: 'Yes, I am retailer',
              content: '예, 리테일업체입니다.'
            },
            {
              value: 'Yes, I am a Tower One market rental tenant',
              content: '네, 저는 Tower 1의 세입자입니다.'
            },
            {
              values: 'Yes, I am a current homeowner',
              content: '예, 현재 주택 소유자입니다.'
            }
          ]
        },
        isTABRetailer: {
          id: 'answers[8553][answers]',
          options: [
            {
              value: 'No',
              content: '아니요'
            },
            {
              values: 'Yes',
              content: '예'
            }
          ]
        },
        isTABTenant: {
          id: 'answers[8557][answers]',
          options: [
            {
              value: 'No',
              content: '아니요'
            },
            {
              values: 'Yes',
              content: '예'
            }
          ]
        },
        isTABHomeowner: {
          id: 'answers[9501][answers]',
          options: [
            {
              value: 'No',
              content: '아니요'
            },
            {
              values: 'Yes',
              content: '예'
            }
          ]
        },
        reasonForPurchase: {
          id: 'reasonForPurchase',
          options: [
            {
              value: 'Principal Residence',
              content: 'Principal Residence'
            },
            {
              values: 'Investment',
              content: 'Investment'
            },
            {
              values: 'For Family',
              content: 'For Family'
            }
          ]
        }
        ,
        numberOfHomesRequested: {
          id: 'numberOfHomesRequested',
          options: [
            {
              value: '1',
              content: '1'
            },
            {
              values: '2',
              content: '2'
            },
            {
              values: '3+',
              content: '3+'
            }
          ]
        },
        numberOfBuyers: {
          id: 'numberOfBuyers',
          options: [
            {
              value: '1',
              content: '(1) One - only me'
            },
            {
              values: '2',
              content: '(2) Two - myself and one other'
            },
            {
              values: '3',
              content: '(3) Three - myself and two others'
            },
            {
              values: '4',
              content: '(4) Four - myself and three others'
            },
            {
              values: 'unsure',
              content: 'I’m unsure at the moment'
            }
          ]
        }
        ,
        colourScheme: {
          id: 'colourScheme',
          options: [
            {
              value: '1',
              content: 'option 1'
            },
            {
              values: '2',
              content: 'option 2'
            }
          ]
        },
        homeOptionOneBeds: {
          id: 'homeOptionOneBeds',
          options: [
            {
              value: 'Studio',
              content: 'Studio'
            },
            {
              values: '1 BR',
              content: '1 BR'
            },
            {
              values: '1 BR + D',
              content: '1 BR + D'
            },
            {
              values: '2 BR',
              content: '2 BR'
            },
            {
              values: '2 BR + D',
              content: '2 BR + D'
            },
            {
              values: '3 BR',
              content: '3 BR'
            },
            {
              values: '3 BR + D',
              content: '3 BR + D'
            },
            {
              values: '4 BR ',
              content: '4 BR'
            }
          ]
        },
        isPermanentResident: {
          id: 'isPermanentResident',
          options: [
            {
              value: 'IS',
              content: '예'
            },
            {
              values: 'IS NOT',
              content: '아니요'
            }
          ]
        },
        isForeignEntity: {
          id: 'isForeignEntity',
          options: [
            {
              value: 'IS',
              content: '예'
            },
            {
              values: 'IS NOT',
              content: '아니요'
            }
          ]
        }
      },
      checkKeepMe: '본인은 SHAPE MARKETING CORP.가 진행하는 주거단지에 대해 VIP 조기 액세스를 위한 정보를 수신하고 해당 주거단지와 관련하여 Shape Marketing Corp.으로부터 이메일 등을 수신하는데 동의합니다. 본인은 info@shapeproperties.com 으로 이메일을 보내거나 3100 - 1090 Pender Street W., Box 315, Vancouver, BC, Canada V6E 0E3으로 우편을 보내 언제든지 수신 동의를 철회할 수 있습니다.',
      submit: '제출하기',
      distclaimer: 'This is not an offering for sale as an offer can only be made when accompanied by a disclosure statement E. & O.E. Sales and Marketing by Shape Marketing.',
    },
  },
  footer: {
    title: <>새로운 프레젠테이션 센터 및<br />견본 주택 곧 오픈 예정 </>,
    address: '4567 LOUGHEED HWY, BURNABY',
    phone: '604.563.8386',
    email: 'info@theamazingbrentwood.com',
    rental: 'Rental Homes',
    shoppingCentre: 'Shopping Centre',
    privacyPolicy: 'privacy policy',
    at: '@the.amazing.brentwood',
  }
};
